import { Log } from '@apparel/core/log';

declare global {
    interface Window {
        dataLayer: any;
    }
}
export class GoogleAnalyticsService {
    private static self: GoogleAnalyticsService;

    static get instance() {
        if (!this.self) {
            this.self = new GoogleAnalyticsService();
        }

        return this.self;
    }

    reportConversion(key, data) {
        window.dataLayer = window.dataLayer || [];
        window?.dataLayer?.push({
            event: key,
            ...(data
                ? {
                      ecommerce: data,
                  }
                : {}),
        });
    }

    public static reportConversion(key, data = null) {
        try {
            return this.instance.reportConversion(key, data);
        } catch (error) {
            Log.error('Error reporting analytic service.', { error });
        }
    }
}
